import { render, staticRenderFns } from "./NoLayout.vue?vue&type=template&id=3d18a5e8&"
import script from "./NoLayout.vue?vue&type=script&lang=js&"
export * from "./NoLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/www/html/film-screening-production/avails/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../var/www/html/film-screening-production/avails/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
